// Dates from the licence server are UTC but often arrive without a time zone (the database's plain
// "timestamp" columns). Read without one, the browser would take them as local time and every
// "il y a ..." would be off by the viewer's offset, so a missing zone means UTC.
export const parseUtc = (value) => {
  if (!value) return null;
  // .NET sends 7 decimals on the seconds; Safari only reads up to 3.
  const text = String(value).replace(/(\.\d{3})\d+/, '$1');
  const hasZone = /([zZ]|[+-]\d{2}:?\d{2})$/.test(text);
  const date = new Date(hasZone || text.length <= 10 ? text : `${text}Z`);
  return Number.isNaN(date.getTime()) ? null : date;
};

export const formatDate = (value) => {
  const date = parseUtc(value);
  return date ? date.toLocaleDateString('fr-FR') : '—';
};

export const formatDateTime = (value) => {
  const date = parseUtc(value);
  return date
    ? date.toLocaleString('fr-FR', { dateStyle: 'short', timeStyle: 'short' })
    : '—';
};

// "à l'instant", "il y a 5 min", "il y a 3 h", "il y a 12 j"
export const timeAgo = (value) => {
  const date = parseUtc(value);
  if (!date) return 'Jamais';
  const minutes = Math.round((Date.now() - date.getTime()) / 60000);
  if (minutes < 1) return "à l'instant";
  if (minutes < 60) return `il y a ${minutes} min`;
  const hours = Math.round(minutes / 60);
  if (hours < 24) return `il y a ${hours} h`;
  const days = Math.round(hours / 24);
  if (days < 60) return `il y a ${days} j`;
  return `le ${date.toLocaleDateString('fr-FR')}`;
};

export const daysUntil = (value) => {
  const date = parseUtc(value);
  return date ? Math.ceil((date.getTime() - Date.now()) / 86400000) : null;
};

export const formatBytes = (bytes) => {
  if (!bytes) return '0 Mo';
  const mb = bytes / (1024 * 1024);
  return mb >= 1024 ? `${(mb / 1024).toFixed(1)} Go` : `${mb.toFixed(1)} Mo`;
};

export const formatAmount = (amount) =>
  `${Number(amount || 0).toLocaleString('fr-FR')} FCFA`;

export const MODE_LABELS = { online: 'En ligne', local: 'Local' };

export const APPROVAL_LABELS = { approved: 'Approuvée', pending: 'En attente', rejected: 'Refusée' };

export const PLATFORM_LABELS = { windows: 'Windows', android: 'Android', ios: 'iPhone / iPad' };
